// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qc_a bhc_rq bhc_kr bhc_ks","PostDetailRight__brandDaysPosts":"qc_b bhc_rq bhc_kr bhc_ks"};